export default __webpack_public_path__ + "static/media/skyline.b1447c50.webp";